import React, { useState, useMemo, useCallback } from "react";
const DIAGRAM_HEIGHT = 350;
const DIAGRAM_WIDTH = 400;

const lumensToCandelas = (lumens, angle) =>
  lumens / (2 * Math.PI * (1 - Math.cos(angle / 2)));

const getIlluminanceAtPoint = (lumenOutput, height, angle) => {
  /*
  console.log('lumenOutput');
  console.log( lumenOutput );
  console.log( height );
  console.log( angle );
  */

  return lumensToCandelas(lumenOutput, angle) / height ** 2;
}

function Diagram({ hit, items }) {
  const [height, setHeight] = useState(3.5);

  const handleChange = useCallback((e) => {
    setHeight(parseFloat(e.target.value));
  }, []);

  const {
    output,
    angleString,
    isSymmetrical,
    angleRadians,
    angleDegrees,
    isComplete,
    radiusPixels,
    radiusMeters,
  } = useMemo(() => {
    const degreesMatch = hit?.ostendoBeamAngle?.match(/(\d+)/g);
    const isSymmetrical =
      degreesMatch?.length === 1 || degreesMatch?.[0] === degreesMatch?.[1];
    const degrees = isSymmetrical ? Number(degreesMatch?.[0]) : 0;

    const angleDegrees = hit ? Number(hit.ostendoBeamAngle) : 45;
    const angleRadians = (degrees || 45) * (Math.PI / 180);

    const radiusMeters = Math.tan(angleRadians / 2) * height;
    const radiusPixels = Math.tan(angleRadians / 2) * DIAGRAM_HEIGHT;

    const output = hit ? Number(hit.ostendoLumenOutput) : 0;

    const required = [
      "ostendoSystemPower",
      "ostendoBeamAngle",
      "ostendoColourTemperature"
    ];


    
    const isComplete =
      items.filter((item) => 
        ["ostendoSystemPower", "ostendoBeamAngle", "ostendoColourTemperature"].includes(item.attribute)
      ).length >= 3;
      
      /*
      console.log( 'isComplete' );
      console.log( isComplete );
      console.log( items );
      */
      
    return {
      output,
      angleString: hit?.ostendoBeamAngle || "45",
      isSymmetrical,
      angleRadians,
      angleDegrees,
      isComplete,
      radiusPixels,
      radiusMeters,
    };
  }, [hit, items, height]);

  if (!isSymmetrical) {
    return (
      <div className="diagram__notice">
        <h5 className="text--center">
          The Illuminance calculator works only for symmetrical beam angles.
        </h5>
      </div>
    );
  }

  return (
    <div>
      <svg className="diagram">
        <g className="diagram__light-source" id="light-source">
          <path
            id="bulb"
            d="M26.0535321,25.1041589 C20.5008307,25.1041589 15.9833238,29.6186164 15.9833238,35.1675696 C15.9833238,40.7165228 20.5008307,45.2299015 26.0535321,45.2299015 C31.6062334,45.2299015 36.1237403,40.7165228 36.1237403,35.1675696 C36.1237403,29.6186164 31.6062334,25.1041589 26.0535321,25.1041589..."
          />
          <path
            id="shade"
            transform="translate(0.473973, 0.916915)"
            d="M50.8307496,35.3890315 C50.8307496,36.2088613 50.1658071,36.8733549 49.3454236,36.8733549..."
          />
        </g>
        <g className="diagram__beam-angle">
          <text className="diagram__label">Beam Angle</text>
          <text className="diagram__value diagram__value--newline">
            {isComplete ? angleString : ""}
          </text>
        </g>
        <g className="diagram__light">
          <line
            className="diagram__light-line"
            x1="174"
            y1="50"
            x2={DIAGRAM_WIDTH / 2 - radiusPixels}
            y2={DIAGRAM_HEIGHT}
            strokeWidth="2"
          />
          <line
            className="diagram__light-line"
            x1="226"
            y1="50"
            x2={DIAGRAM_WIDTH / 2 + radiusPixels}
            y2={DIAGRAM_HEIGHT}
            strokeWidth="2"
          />
          <ellipse
            className="diagram__light-area"
            cx={DIAGRAM_WIDTH / 2}
            cy={DIAGRAM_HEIGHT}
            rx={radiusPixels - 5}
            ry="35"
            strokeWidth="2"
          />
          <circle
            className="diagram__dot"
            cx={DIAGRAM_WIDTH / 2}
            cy={DIAGRAM_HEIGHT - 35}
            r="5"
          />
          <circle
            className="diagram__dot"
            cx={DIAGRAM_WIDTH / 2}
            cy={DIAGRAM_HEIGHT + 35}
            r="5"
          />
        </g>
        <line
          className="diagram__distance-line"
          strokeDasharray="5, 5"
          x1={DIAGRAM_WIDTH / 2}
          y1="50"
          x2={DIAGRAM_WIDTH / 2}
          y2={DIAGRAM_HEIGHT - 35}
        />
        <foreignObject
          className="diagram__height-input"
          width="120"
          height="150"
          x="142px"
          y="150px"
        >
          <label className="diagram__label" htmlFor="height-input">
            Height
          </label>
          <input
            id="height-input"
            type="number"
            step="0.25"
            min="0.25"
            value={height}
            onChange={handleChange}
          />
        </foreignObject>
        <foreignObject className="diagram__illuminance" width="350" height="50">
          <span className="diagram__label">Approx. Illuminance</span>
          <span className="diagram__value">
            {isComplete
              ? `${getIlluminanceAtPoint(output, height, angleRadians).toFixed(2)}lx`
              : ""}
          </span>
        </foreignObject>
        <line
          strokeDasharray="5, 5"
          x1={DIAGRAM_WIDTH / 2}
          y1={DIAGRAM_HEIGHT}
          x2={DIAGRAM_WIDTH / 2 + radiusPixels}
        />
        <g className="diagram__diameter">
          <text className="diagram__label" textAnchor="middle">
            Diameter
          </text>
          <text
            className="diagram__value diagram__value--newline"
            textAnchor="middle"
          >
            {isComplete ? `${(radiusMeters * 2).toFixed(2)}m` : ""}
          </text>
        </g>
      </svg>
    </div>
  );
}
export default Diagram;